import { useI18n } from '../context/I18nContext';
import { en } from '../locales/en';
import { ar } from '../locales/ar';

const translations = {
  en,
  ar
};

export const useTranslation = () => {
  const { language, switchLanguage, isRTL, syncLanguageFromUser, refreshTrigger } = useI18n();
  
  const t = (key, variables = {}) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to English if translation not found
        value = translations.en;
        for (const k of keys) {
          if (value && value[k]) {
            value = value[k];
          } else {
            return key; // Return the key itself if translation doesn't exist
          }
        }
        break;
      }
    }
    
    let result = value || key;
    
    // Replace variables in the translation string
    if (typeof result === 'string' && Object.keys(variables).length > 0) {
      Object.keys(variables).forEach(varKey => {
        const varValue = variables[varKey];
        // Replace simple placeholders: {varKey}
        result = result.replace(new RegExp(`\\{${varKey}\\}`, 'g'), varValue);
      });
    }
    
    return result;
  };

  return {
    t,
    switchLanguage,
    language,
    isRTL,
    syncLanguageFromUser,
    refreshTrigger
  };
};